import { AGENCY_PROFILE_TYPES, INDIVIDUAL, NETWORK, OFFICE, PROFILE_TYPES, ProfileType, TEAM } from '../../types/profile.type';

type ProfileTypeInput = ProfileType | { profileType: ProfileType };

type NullableProfileTypeInput = ProfileTypeInput | undefined | null;

type NarrowedProfileType<T, P extends ProfileType> = T extends ProfileType
  ? Extract<T, P>
  : T extends { profileType: ProfileType }
    ? T & { profileType: P }
    : never;

function getProfileType(profileType: ProfileTypeInput): ProfileType {
  return typeof profileType === 'string' ? profileType : profileType.profileType;
}

export function isProfileType(value: string): value is ProfileType {
  return (PROFILE_TYPES as readonly string[]).includes(value);
}

export function isIndividual<T extends NullableProfileTypeInput>(profileType: T): profileType is NarrowedProfileType<T, typeof INDIVIDUAL> {
  return profileType ? getProfileType(profileType) === INDIVIDUAL : false;
}

export function isTeam<T extends NullableProfileTypeInput>(profileType: T): profileType is NarrowedProfileType<T, typeof TEAM> {
  return profileType ? getProfileType(profileType) === TEAM : false;
}

export function isOffice<T extends NullableProfileTypeInput>(profileType: T): profileType is NarrowedProfileType<T, typeof OFFICE> {
  return profileType ? getProfileType(profileType) === OFFICE : false;
}

export function isNetwork<T extends NullableProfileTypeInput>(profileType: T): profileType is NarrowedProfileType<T, typeof NETWORK> {
  return profileType ? getProfileType(profileType) === NETWORK : false;
}

export function isAgency<T extends NullableProfileTypeInput>(
  profileType: T,
): profileType is NarrowedProfileType<T, typeof OFFICE | typeof TEAM> {
  if (!profileType) {
    return false;
  }
  const type = getProfileType(profileType);

  return AGENCY_PROFILE_TYPES.includes(type);
}
